import { render, staticRenderFns } from "./repeatCooperation.vue?vue&type=template&id=f70b8112&scoped=true"
import script from "./repeatCooperation.vue?vue&type=script&lang=js"
export * from "./repeatCooperation.vue?vue&type=script&lang=js"
import style0 from "./repeatCooperation.vue?vue&type=style&index=0&id=f70b8112&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f70b8112",
  null
  
)

export default component.exports